import Color from "../../colors/Color";
import { VariableReference } from "../../variables/Variables";

export const SHADOW_TYPES = ["outer", "inner"] as const;

export type ShadowType = typeof SHADOW_TYPES[number];

export default interface Shadow {
    type: ShadowType;
    offsetX: number;
    offsetY: number;
    blurRadius: number;
    spread: number;
    color: Color;
    variableReferences?: VariableReference[];
}
